import React from "react";

const contactList = () => {
  return <div>contactList</div>;
};

export default contactList;
